<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/aVd7Y1/tc-custom/9781460344781.jpg?1697739313614" alt="This image is the cover for the book Playing the Rake's Game, Rakes of the Caribbean"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Playing the Rake's Game, Rakes of the Caribbean
      </h1>
      <p class="bookDescription body article font2">
        <b>Don't miss the next book in Bronwyn Scott's scorching Rakes of the Caribbean miniseries, <i>BREAKING THE RAKE'S RULES</i>, available now!</b><br/><br/><b>Ren Dryden has a spark she can't risk igniting</b><b> </b><br/><br/>Emma Ward is in trouble. The devilishly handsome part-owner of her beloved Caribbean sugar plantation has arrived, and clearly he doesn't trust her. But his eyes promise pleasures she can only imagine. Maybe there's a way to get him onside <br/><br/>Ren Dryden may be fresh off the boat from London, but he knows when a woman is playing himand when she's as intriguing as the alluring Emma, he's more than happy to play back! But several sultry nights and secrets shared later, Ren realizes just how high the stakes are in this game of seduction! <br/><br/>Rakes of the Caribbean <br/><br/>Sun, sand and sizzling seduction
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bronwyn Scott
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?aa77cb30